import React from "react";
import {Steps} from 'antd';
import { StickyContainer, Sticky } from 'react-sticky';
import {t} from '../../../constant/i18n';

const {Step} = Steps;

class FIl extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            step:this.props.step
        }
    }
    render() {
        return (
            <div style={{textAlign: "center"}}>

                    <Steps direction="vertical" current={this.state.step}>
                        <Step title={t('fil.step1')} description={t('fil.chooseProject')}/>
                        <Step title={t('fil.step2')} description={t('fil.globalongAccount')}/>
                        <Step title={t('fil.step3')} description={t('fil.createFile')}/>
                    </Steps>

            </div>
        )
    }
}

export default FIl;